export const TIMESERIES_X_EXTENTS = {
	districts: {
		mth: [2009,2024],
		ela: [2009,2024],
		abs: [2017,2023]
	},
	states: {
		mth: [2009,2024],
		ela: [2009,2024],
		abs: [2017,2023]
	}
}
export const TIMESERIES_X_EXTENTS_MISSING = {
	districts: {
		mth: [2019,2022],
		ela: [2019,2022],
		abs: [2019,2022]
	},
	states: {
		mth: [2019,2022],
		ela: [2019,2022],
		abs: [2019,2022]
	}
}

export const TIMESERIES_Y_EXTENTS = {
	districts: {
		mth: [-2, 2],
		ela: [-2, 2],
		abs: [0, 1]
	},
	states: {
		mth: [-2, 2],
		ela: [-2, 2],
		abs: [0, 1]
	}
}